import { apiFetch } from "../utils/apiFetch";
import React from "react";

const RemoveMembers = ({
  setMemberRemovePopup,
  memberRemovePopup,
  setMembers,
  workspace,
}) => {
  const handleRemove = async () => {
    try {
      const res = await apiFetch(
        `${process.env.API_URL}/api/workspace/${workspace._id}/members/${memberRemovePopup.id}`,
        {
          method: "DELETE",
          },
      );

      if (!res.ok) {
        throw new Error(res.status + ": " + res.statusText);
      }

      const data = await res.json();

      setMemberRemovePopup(null);

      setMembers((prev) =>
        prev.filter(
          (memberInfo) =>
            String(memberInfo.userId._id) !== String(data.removedId),
        ),
      );
    } catch (err) {
      alert(err.message);
    }
  };

  return (
    <div
      onClick={() => setMemberRemovePopup(null)}
      className="fixed inset-0 bg-black/40 flex justify-center items-center z-50"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-[40dvw]  bg-white rounded-lg p-6"
      >
        <div className="flex flex-col gap-2 text-center sm:text-left">
          <h2 className="text-lg font-semibold">Remove Member</h2>
          <p className="text-[#717182] text-sm">
            Are you sure you want to remove{" "}
            <strong>{memberRemovePopup.username.toUpperCase()}</strong> from
            this group? They will lose access to all channels and messages.
          </p>
        </div>
        <div className="flex flex-col-reverse gap-2 sm:flex-row sm:justify-end mt-6">
          <button
            onClick={() => setMemberRemovePopup(null)}
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive border bg-background text-foreground hover:bg-accent hover:text-accent-foreground dark:bg-input/30 dark:border-input dark:hover:bg-input/50 h-9 px-4 py-2 has-[>svg]:px-3"
          >
            Cancel
          </button>
          <button
            onClick={handleRemove}
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive text-white h-9 px-4 py-2 has-[>svg]:px-3 bg-red-600 hover:bg-red-700 focus:ring-red-600"
          >
            Remove
          </button>
        </div>
      </div>
    </div>
  );
};

export default RemoveMembers;
